import type { BossConfig } from '../types';

export const BOSSES: Record<5 | 10 | 15 | 20, BossConfig> = {
  5: {
    key: 'wolf',
    triggerLevel: 5,
    displayName: 'Forest Wolf',
    hp: 40,
    attacks: [
      { name: 'Bite', damage: 6, weight: 3 },
      { name: 'Howl', damage: 4, weight: 2 },
    ],
    playerAttackDamage: 8,
    playerDefendReduction: 0.5,
    drawColors: { primary: 0x6b6f78, secondary: 0x3d4048, accent: 0xf2c14e },
  },
  10: {
    key: 'serpent',
    triggerLevel: 10,
    displayName: 'River Serpent',
    hp: 65,
    attacks: [
      { name: 'Splash', damage: 7, weight: 3 },
      { name: 'Bite', damage: 9, weight: 2 },
    ],
    playerAttackDamage: 9,
    playerDefendReduction: 0.5,
    drawColors: { primary: 0x2c8a6a, secondary: 0x1d5a48, accent: 0xeacf8c },
  },
  15: {
    key: 'bear',
    triggerLevel: 15,
    displayName: 'Hill Bear',
    hp: 90,
    attacks: [
      { name: 'Swipe', damage: 11, weight: 3 },
      { name: 'Roar', damage: 6, weight: 2 },
    ],
    playerAttackDamage: 10,
    playerDefendReduction: 0.5,
    drawColors: { primary: 0x6b3e1a, secondary: 0x402610, accent: 0xeacf8c },
  },
  20: {
    key: 'dragon',
    triggerLevel: 20,
    displayName: 'Mountain Dragon',
    hp: 130,
    attacks: [
      { name: 'Bite', damage: 12, weight: 2 },
      { name: 'Fire Breath', damage: 16, weight: 2 },
      { name: 'Wing Slam', damage: 9, weight: 2 },
    ],
    playerAttackDamage: 11,
    playerDefendReduction: 0.5,
    drawColors: { primary: 0xc23b3b, secondary: 0x6b1a1a, accent: 0xf2c14e },
  },
};
